import * as React from "react";
import {Box,Stack,Typography} from "@mui/material";
import moment from 'moment';

const TodayEventsHeader = ({startDate}) => {
    const todayNumber = moment(startDate).format("D");
    const todayDay = moment(startDate).format("dddd");
    const todayMonth = moment(startDate).format("MMMM");
    return(
        <Box sx={{backgroundColor:'#F4D5DE',height:'44px',padding:1.5,color:'#263238'}}>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{marginTop:'-8px'}}
            >
                <Stack
                    direction="row"
                    justifyContent="left"
                    alignItems="center"
                    spacing={1}
                    sx={{marginTop:0.5}}
                >
                    <Typography sx={{fontSize:'44px',lineHeight:1}}>
                        {todayNumber}
                    </Typography>
                    <Stack
                        direction="column"
                        justifyContent="left"
                        alignItems="flex-start"
                        variant={'subtitle3'}
                        spacing={0}
                    >
                        <Typography>
                            {todayDay}
                        </Typography>
                        <Typography>
                            {todayMonth}
                        </Typography>
                    </Stack>

                </Stack>
                <Box sx={{background:'rgba(255, 255, 255, 0.4)', padding:0.7,borderRadius:1}}>
                    <Typography variant={'subtitle3'}>Aujourd'hui</Typography>
                </Box>
            </Stack>
        </Box>
    )
}

export default TodayEventsHeader;